import Vue from 'vue'
import config from '@/config/index'

export default {
  namespaced: true,
  getters: {
    uploadUrl: (state) => {
      return `${config.serverURI}/activityGens/upload`
    }
  },
  actions: {
  	loadItems ({ commit, dispatch }, payload) {
      console.log('-> loadItems')
      return Vue.axios.get(`${config.serverURI}/activityGens`)
    },
    loadItemsAsPage ({ commit, dispatch }, pagination) {
      console.log('-> loadItemsAsPage', pagination)
      return Vue.axios.get(`${config.serverURI}/activityGens/page`, { params: pagination })
    },
    create ({ commit, dispatch }, payload) {
      console.log('-> create', payload)
      return Vue.axios.post(`${config.serverURI}/activityGens`, payload)
    },
    update ({ commit, dispatch }, payload) {
      console.log('-> update', payload)
      return Vue.axios.put(`${config.serverURI}/activityGens/${payload.id}`, payload)
    },
    delete ({ commit, dispatch }, payload) {
      console.log('delete', payload)
      return Vue.axios.delete(`${config.serverURI}/activityGens/${payload.id}`)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/activityGen.js